import { render, staticRenderFns } from "./CandidatesBulkActionsButton.vue?vue&type=template&id=7af28b38&"
import script from "./CandidatesBulkActionsButton.vue?vue&type=script&lang=js&"
export * from "./CandidatesBulkActionsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports